module.exports = __webpack_public_path__ + "img/dc-circles.1d72a40.svg";